import { render, staticRenderFns } from "./subprogram-importer-page.vue?vue&type=template&id=352d0966&"
import script from "./subprogram-importer-page.vue?vue&type=script&lang=js&"
export * from "./subprogram-importer-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports